import { render, staticRenderFns } from "./HeaderMobileAside.vue?vue&type=template&id=2ea50112"
import script from "./HeaderMobileAside.vue?vue&type=script&lang=ts"
export * from "./HeaderMobileAside.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports